/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Sdmedizin9Inputs */

const en__field_enum_sdmedizin9 = /** @type {(inputs: _Field_Enum_Sdmedizin9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`16 - Medizin`)
};

const de__field_enum_sdmedizin9 = /** @type {(inputs: _Field_Enum_Sdmedizin9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`16 - Medizin`)
};

/**
* | output |
* | --- |
* | "16 - Medizin" |
*
* @param {_Field_Enum_Sdmedizin9Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_sdmedizin9 = /** @type {((inputs?: _Field_Enum_Sdmedizin9Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Sdmedizin9Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_sdmedizin9(inputs)
	return de__field_enum_sdmedizin9(inputs)
});
export { _field_enum_sdmedizin9 as "_field_enum_SDMEDIZIN" }